export enum EventType {
  Exit = "Exit",
  Scenario3Stage1 = "Scenario3Stage1",
  Scenario3Stage2 = "Scenario3Stage2",
  Scenario4 = "Scenario4",
  Scenario5Stage1 = "Scenario5Stage1",
  Scenario5Stage2 = "Scenario5Stage2",
  Intro = "Intro",
  ShowWarning = "ShowWarning",
  HideWarning = "HideWarning",
  ShowInfoWithButton = "ShowInfoWithButton",
  ShowInfoWithoutButton = "ShowInfoWithoutButton",
  HideInfo = "HideInfo",
  ShowUserGuide = "ShowUserGuide",
  Survey = "Survey",
  ShowWarningAndInfo = "ShowWarningAndInfo",
  ShowLoader="ShowLoader",
  HideLoader="HideLoader",
  CurrentLocation="CurrentLocation",
  SetLocationInfo="SetLocationInfo",
  HideProgressLoader="HideProgressLoader",
  ExperienceStart="ExperienceStart",
  Scenario3Stage1Finish = "Scenario3Stage1Finish",
  Scenario3Stage2Finish = "Scenario3Stage2Finish",
  Scenario4Finish = "Scenario4Finish",
  MRIisFixed = "MRIisFixed",
  Scenario5Stage1Finish = "Scenario5Stage1Finish",
  Scenario5Stage2Finish = "Scenario5Stage2Finish",
  Replay = "Replay",
  ChatPing = "ChatPing",
  Audio = "Audio",
  IncompatibleDevice="IncompatibleDevice",
  IncompatibleBrowser="IncompatibleBrowser",
  CompatibilityCheck="CompatibilityCheck"
}

export type EventCallback = (event: EventType, data: any) => void;

export class AppManager {
  private appMessageCallback: EventCallback = () => {};

  private hostMessageCallback: EventCallback = () => {};

  sendMessageToApp = (e: EventType, data: any) => {
    this.appMessageCallback && this.appMessageCallback(e, data);
  };

  sendMessageToHost = (e: EventType, data: any) => {
    this.hostMessageCallback && this.hostMessageCallback(e, data);
  };

  registerAppMessageCallback = (eventFunction: EventCallback) => {
    this.appMessageCallback = eventFunction;
  };

  registerHostMessageCallback = (eventFunction: EventCallback) => {
    this.hostMessageCallback = eventFunction;
  };
}

export const appManager = new AppManager();
